export default __webpack_public_path__ + "static/media/search-blue-icon.5179ecdb.svg";